export default __webpack_public_path__ + "static/media/segoeui.8faf04df.ttf";